"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'shortcuts.prompt.title': 'Alternar Prompts Avanzados',
    'shortcuts.prompt.description': 'Habilita o deshabilita la estructura de prompts avanzada y el sistema de slots',
};
